var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-view"},[_c('iframe',{attrs:{"src":_vm.courseTabDetails.redirectUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }